import React from "react";
import { ModuleDisclaimer } from "@carfax/contentful/PageModularModule";
import { DisclaimerText } from "@carfax/web-ui/components/DisclaimerText";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

interface Props {
  module?: ModuleDisclaimer;
}

const LegalDisclaimer: React.FC<Props> = ({ module }) => {
  return module ? <DisclaimerText>{documentToReactComponents(module.textContent)}</DisclaimerText> : null;
};

export default LegalDisclaimer;
